import { useEffect, useRef, useState } from "react";

const CIPHER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/#*—・";

function scramble(text) {
  return text
    .split("")
    .map((c) => (c === " " ? " " : CIPHER[Math.floor(Math.random() * CIPHER.length)]))
    .join("");
}

export default function ScrambleText({
  text,
  className = "",
  as: Tag = "span",
  duration = 1400,
  delay = 0,
  testId,
}) {
  const [display, setDisplay] = useState(() => scramble(text));
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !started.current) {
            started.current = true;
            const chars = text.split("");
            const start = performance.now() + delay;
            let raf;
            const tick = (now) => {
              const t = Math.max(0, (now - start) / duration);
              const revealed = Math.floor(t * chars.length);
              setDisplay(
                chars
                  .map((c, i) => {
                    if (c === " ") return " ";
                    if (i < revealed) return c;
                    return CIPHER[Math.floor(Math.random() * CIPHER.length)];
                  })
                  .join("")
              );
              if (t < 1) raf = requestAnimationFrame(tick);
              else setDisplay(text);
            };
            raf = requestAnimationFrame(tick);
          }
        });
      },
      { threshold: 0.5 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [text, duration, delay]);

  return (
    <Tag ref={ref} className={className} data-testid={testId}>
      {display}
    </Tag>
  );
}
